import { I18n } from '@boschebike/ebds-js';
import { PageNavigationRouterLink } from '../components';
import { conditionalEntries } from '../helpers';
import { ServiceGeneralPage } from '../pages/data-act/services/ServiceGeneralPage';
import { ServiceTinkererPage } from '../pages/data-act/services/ServiceTinkererPage';
import { DataProcessingAgreementPage } from '../pages/data-processing-agreement/DataProcessingAgreementPage';
import { TermsOfUseForDealersSubPortal } from '../pages/terms-of-use-for-dealers-sub-portal/TermsOfUseForDealersSubPortal';
import { ServiceAbsPlannerPage } from '../pages/terms-of-use-for-manufacturer-services/services/ServiceAbsPlannerPage';
import { ServiceContentCardCreatorPage } from '../pages/terms-of-use-for-manufacturer-services/services/ServiceContentCardCreatorPage';
import { ServiceSpecSheetPage } from '../pages/terms-of-use-for-manufacturer-services/services/ServiceSpecSheetPage';
import { ServiceThemeEditorPage } from '../pages/terms-of-use-for-manufacturer-services/services/ServiceThemeEditorPage';
import { TermsOfUseForManufacturerServicesPage } from '../pages/terms-of-use-for-manufacturer-services/TermsOfUseForManufacturerServicesPage';
import { TermsOfUseForSubusersPage } from '../pages/terms-of-use-for-subusers/TermsOfUseForSubusersPage';
import { TermsOfUsePage } from '../pages/terms-of-use/TermsOfUsePage';
import { DATA_ACT_LOCATIONS, MANUFACTURER_SERVICES_LOCATIONS, TERMS_OF_USE_LOCATIONS } from './routerLocations';
import { ServiceEbikePicturesPage } from '../pages/terms-of-use-for-manufacturer-services/services/ServiceEbikePicturesPage';
import { ServiceEbikeManualsPage } from '../pages/terms-of-use-for-manufacturer-services/services/ServiceEbikeManualsPage';

interface TermsOfUseRoutesOptions {
  isDPASupported: boolean;
  isDXF: boolean;
}

export const termsOfUseRoutes = (content: I18n, options: TermsOfUseRoutesOptions): PageNavigationRouterLink[] => [
  {
    id: '100',
    route: TERMS_OF_USE_LOCATIONS.TERMS_OF_USE, // NOTE: as originally on prod, the country-specific page (-us, -au) cannot be reached via header tab.
    text: content.t('portal.termsOfUse.label'),
    component: TermsOfUsePage,
  },
  {
    id: '200',
    route: TERMS_OF_USE_LOCATIONS.TERMS_OF_USE_FOR_SUB_USERS,
    text: content.t('portal.termsOfUse.subUsers.label'),
    component: TermsOfUseForSubusersPage,
  },
  {
    id: '300',
    route: TERMS_OF_USE_LOCATIONS.TERMS_OF_USE_FOR_DEALERS_SUB_PORTAL,
    text: content.t('portal.termsOfUse.dealersSubPortal.label'),
    component: TermsOfUseForDealersSubPortal,
  },
  {
    id: '400',
    route: TERMS_OF_USE_LOCATIONS.TERMS_OF_USE_FOR_MANUFACTURER_SERVICES,
    text: content.t('portal.termsOfUse.manufacturerServices.label'),
    component: TermsOfUseForManufacturerServicesPage,
  },
  ...conditionalEntries(options.isDPASupported, {
    id: '500',
    route: TERMS_OF_USE_LOCATIONS.DATA_PROCESSING_AGREEMENT,
    text: content.t('portal.data.processingAgreement.label'),
    component: DataProcessingAgreementPage,
  }),
  ...conditionalEntries(!options.isDXF, {
    id: '600',
    route: TERMS_OF_USE_LOCATIONS.DATA_ACT,
    text: content.t('portal.dataAct.services.label'),
    component: TermsOfUseForManufacturerServicesPage,
  }),
];

export const dealerServicesRoutes = (content: I18n): PageNavigationRouterLink[] => [
  {
    id: '410',
    route: MANUFACTURER_SERVICES_LOCATIONS.THEME_EDITOR,
    text: content.t('portal.termsOfUse.manufacturerServices.themeEditor.label'),
    component: ServiceThemeEditorPage,
  },
  {
    id: '420',
    route: MANUFACTURER_SERVICES_LOCATIONS.CONTENT_CARD_CREATOR,
    text: content.t('portal.termsOfUse.manufacturerServices.contentCardCreator.label'),
    component: ServiceContentCardCreatorPage,
  },
  {
    id: '430',
    route: MANUFACTURER_SERVICES_LOCATIONS.SPEC_SHEET,
    text: content.t('portal.termsOfUse.manufacturerServices.eBikeSpecSheet.label'),
    component: ServiceSpecSheetPage,
  },
  /* Hide Production Logs Label from navigation: required by PORTAL-3777
    {
      id: '440',
      route: DEALER_SERVICES_LOCATIONS.PRODUCTION_LOGS,
      text: content.t('portal.termsOfUse.manufacturerServices.productionLogs.label'),
      component: ServiceProductionLogsPage,
    },
*/
  {
    id: '450',
    route: MANUFACTURER_SERVICES_LOCATIONS.ABS_PLANNER,
    text: content.t('portal.termsOfUse.manufacturerServices.absPlanner.label'),
    component: ServiceAbsPlannerPage,
  },
  {
    id: '460',
    route: MANUFACTURER_SERVICES_LOCATIONS.EBIKE_PICS,
    text: content.t('portal.termsOfUse.manufacturerServices.ebikePictures.label'),
    component: ServiceEbikePicturesPage,
  },
  {
    id: '470',
    route: MANUFACTURER_SERVICES_LOCATIONS.EBIKE_MANS,
    text: content.t('portal.termsOfUse.manufacturerServices.ebikeManuals.label'),
    component: ServiceEbikeManualsPage,
  },
];

export const dataActServiceRoutes = (content: I18n): PageNavigationRouterLink[] => [
  {
    id: '610',
    route: DATA_ACT_LOCATIONS.GENERAL,
    text: content.t('portal.dataAct.services.general.label'),
    component: ServiceGeneralPage,
  },
  {
    id: '620',
    route: DATA_ACT_LOCATIONS.TINKERER,
    text: content.t('portal.dataAct.services.tinkerer.label'),
    component: ServiceTinkererPage,
  },
];
